export default __webpack_public_path__ + "static/media/blank_avatar.1fb3c57a.svg";